import styled from 'styled-components/macro';
import { layout, space } from 'styled-system';
import ebLogo from 'img/eb-logo.svg';
import Flex from './Flex';

const RPIcon: any = styled.img`
  ${space};
  ${layout};
`;

const EBLogo = ({ width }: any) => {
  return (
    <Flex justifyCenter>
      <RPIcon src={ebLogo} width={width || ['90%', '75%']} alt="EulerBeats" />
    </Flex>
  );
};

export default EBLogo;
